import React, { useState, useEffect } from "react";
import OrgChart from "@balkangraph/orgchart.js";
import { makeStyles, Dialog, DialogContent } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import "./balkan.css";
import {
  updateDepartments,
  getAdminDepartments,
} from "../../../actions/admin-actions";
import ActionMessages from "../../../common-components/ActionMessages";

const DepartmentHierarchy = ({ nodesData, departmentsResources }) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [chart, setChart] = useState(null);
  const [nodeObj, setNodeObj] = useState({
    code: "",
    status: null,
    name: "",
    description: null,
    resource: null,
    resourceId: null,
  });
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [pId, setPId] = useState(null);
  const [nodeId, setNodeId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [btnText, setBtnText] = useState("Add");
  const [isEditing, setIsEditing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [isRearranged, setIsRearranged] = useState(false);
  const [nodes, setNodes] = useState([]);
  const [rearrangedNodeData, setRearrangedNodeData] = useState({
    id: "",
    pid: "",
  });
  const updateDepartmentsData = useSelector(
    (state) => state.adminReducer.updateDepartmentsData
  );
  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };
  const useStyles = makeStyles({
    addSection: {
      display: "flex",
    },
    addDialog: {
      width: "350px",
      position: "relative",
    },
    fieldTitle: {
      fontWeight: 600,
      marginBottom: "4px",
      fontSize: "13px",
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      padding: "5px",
      height: "100%",
    },
    dropDown: {
      outline: "none",
      borderRadius: "5px",
      padding: "5px",
      border: "1px solid #ccc",
    },
    inputField: {
      outline: "none",
      padding: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "14px",
      fontWeight: "500",
      letterSpacing: "0.5px",
      marginBottom: "10px",
    },
    buttonsContainer: {
      margin: "10px 0",
      textAlign: "center",
    },
    btn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "10px 15px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      // margin: "2px 0 2px 8px",
      cursor: "pointer",
    },
    popupHeader: {
      marginTop: "-20px",
      marginLeft: "-24px",
      marginRight: "-24px",
      background: "#4b5558",
    },
    closeIconAdd: {
      display: "inline-block",
      color: "black",
      background: "#ffff",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      cursor: "pointer",
      textAlign: "center",
      position: "absolute",
      top: "5px",
      right: "8px",
      fontSize: "13px",
      fontWeight: 600,
    },
    addDelegationTitle: {
      height: "28px",
      textAlign: "center",

      fontWeight: 600,
      paddingTop: "5px",
      color: "#ffff",
    },
  });
  const classes = useStyles();

  const formatText = (text) => {
    if (text) {
      text = text.trim();
      let result = "";
      let arr = text.split(" ");
      arr.forEach(
        (word) =>
          word &&
          word.length > 0 &&
          (result += `${word[0].toUpperCase()}${word.slice(1)} `)
      );
      return result;
    }
  };

  const resourcesFormatted = departmentsResources.map((resource) => ({
    label: formatText(resource.resourceName),
    value: resource.resourceName,
    resourceId: resource.resourceId,
  }));

  const resetValues = () => {
    setNodeObj({
      code: "",
      status: "",
      name: "",
      description: "",
      resource: null,
      resourceId: null,
    });
    setPId(null);
    setModalOpen(false);
    setBtnText("Add");
    setIsEditing(false);
    setIsRemoving(false);
  };

  const addNewNode = () => {
    if (nodeObj.code && nodeObj.name) {
      const { code, status, name, description, resourceId } = nodeObj;
      const newNode = {
        department_id: null,
        department: name,
        parent_department_id: pId ? pId : null,
        is_active: true,
        department_code: code,
        status,
        short_description: description,
        resource_id: resourceId,
        row_order: 0,
      };
      dispatch(updateDepartments(newNode));
      setModalOpen(false);
    } else {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText(
        !nodeObj.name
          ? "Department name is required."
          : "Department code is required."
      );
    }
  };

  const onEdit = (id) => {
    setBtnText("Update");
    setNodeId(id);
    setIsEditing(true);
  };

  const updateNode = () => {
    if (nodeObj.code && nodeObj.name) {
      const node = nodesData.filter((obj) => obj.department_id == nodeId);
      node[0].department = nodeObj.name;
      node[0].status = nodeObj.status;
      node[0].department_code = nodeObj.code;
      node[0].short_description = nodeObj.description;
      node[0].resource_id = nodeObj.resourceId;
      node[0].row_order = 0;
      node[0].is_active = true;
      dispatch(updateDepartments(node[0]));
      setNodeId(null);
      setModalOpen(false);
    } else {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText(
        !nodeObj.name
          ? "Department name is required."
          : "Department code is required."
      );
    }
  };

  const onRemove = (id) => {
    setIsRemoving(true);
    setNodeId(id);
  };

  const removeNode = () => {
    const nodesArr = nodes.filter((obj) => obj.id == nodeId);
    const existingNodesArr = nodesData.filter(
      (obj) => obj.department_id == nodeId
    );
    nodesArr[0].is_active = false;
    nodesArr[0].is_updated = true;
    nodesArr[0] = { ...existingNodesArr[0], ...nodesArr[0] };
    dispatch(updateDepartments(nodesArr[0]));
    setNodeId(null);
    setModalOpen(false);
    setIsRemoving(false);
  };

  const onRearrangeNode = (id, pid) => {
    const node = nodesData.filter((obj) => obj.department_id == id);
    if (node && node.length > 0) {
      node[0].parent_department_id = pid;
      dispatch(updateDepartments(node[0]));
    }
  };
  // useEffect(() => {
  //   document.addEventListener("click", (e) => {

  //   });
  // }, []);
  useEffect(() => {
    if (rearrangedNodeData.id) {
      onRearrangeNode(rearrangedNodeData.id, rearrangedNodeData.pid);
      // setIsRearranged(false);
    }
  }, [isRearranged, rearrangedNodeData]);
  useEffect(() => {
    if (updateDepartmentsData.status && updateDepartmentsData.status === 200) {
      setMsgType("success");
      setEmptyErrMsg(true);
      setMsgText("Departments updated successfully");
      // dispatch(getAdminDepartments());
      updateDepartmentsData.status = null;
    } else if (
      updateDepartmentsData.status &&
      updateDepartmentsData.status === 400
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText(updateDepartmentsData.message);
      // dispatch(getAdminDepartments());
      updateDepartmentsData.status = null;
    }
  }, [updateDepartmentsData]);
  useEffect(() => {
    if (nodesData && nodesData.length > 0) {
      const arr = [];
      nodesData.forEach((obj) => {
        let parentNode = nodesData.filter(
          (node) => node.department_id == obj.parent_department_id
        );
        const nodeobj = {
          // ...obj,
          id: obj.department_id,
          pid: obj.parent_department_id,
          code: obj.department_code,
          status: obj.status ? obj.status : "",
          name: obj.department,
          resource: obj.resource_name,
          description: obj.short_description ? obj.short_description : "",
        };
        // if (parentNode && parentNode.length > 0) {
        //   nodeobj.sub = formatText(parentNode[0].department);
        // } else {
        //   nodeobj.sub = "NA";
        // }
        if (!obj.parent_department_id) delete nodeobj.pid;
        arr.push(nodeobj);
      });
      setNodes([...arr]);
    } else {
      setNodes([]);
    }
  }, [nodesData]);
  const drawBalkanChart = () => {
    OrgChart.templates.ana.field_0 =
      '<text class="field_0" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 14px; font-weight:bolder" fill="#ffffff" x="125" y="30" text-anchor="middle">{val}</text>';
    OrgChart.templates.ana.field_1 =
      '<text class="field_1" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 12px; font-weight:600" fill="#ffffff" x="125" y="60" text-anchor="middle">{val}</text>';
    OrgChart.templates.ana.field_2 =
      '<text class="field_0" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 12px; font-weight:600" fill="#ffffff" x="125" y="90" text-anchor="middle">{val}</text>';
    // OrgChart.templates.ana.field_3 =
    //   '<text class="field_1" data-width="230" data-text-overflow="multiline-4-ellipsis" style="font-size: 18px;" fill="#ffffff" x="125" y="110" text-anchor="middle">Desc: {val}</text>';
    // OrgChart.templates.ana.field_4 =
    //   '<text class="field_1" style="font-size: 18px;" fill="#ffffff" x="125" y="140" text-anchor="middle">Manager: {val}</text>';
    // OrgChart.templates.ana.field_5 =
    //   '<text class="field_1" style="font-size: 18px;" fill="#ffffff" x="125" y="170" text-anchor="middle">Sub Dept: {val}</text>';
    OrgChart.elements.myTextArea = function (
      data,
      editElement,
      minWidth,
      readOnly
    ) {
      var id = OrgChart.elements.generateId();
      var value = data[editElement.binding];
      if (value == undefined) value = "";
      if (readOnly && !value) {
        return {
          html: "",
        };
      }
      var rOnlyAttr = readOnly ? "readonly" : "";
      var rDisabledAttr = readOnly ? "disabled" : "";
      return {
        html: `<label for="${id}" style="color:#a39f9f;font-weight:600;">${editElement.label}</label>
                        <textarea ${rDisabledAttr} ${rOnlyAttr} id="${id}" name="${id}" style="width: 100%;height: 100px; resize: none; background:#fff; color:#a39f9f;font-weight:600; border:none" data-binding="${editElement.binding}">${value}</textarea>`,
        id: id,
        value: value,
      };
    };
    OrgChart.elements.nameTextArea = function (
      data,
      editElement,
      minWidth,
      readOnly
    ) {
      var id = OrgChart.elements.generateId();
      var value = data[editElement.binding];
      if (value == undefined) value = "";
      if (readOnly && !value) {
        return {
          html: "",
        };
      }
      var rOnlyAttr = readOnly ? "readonly" : "";
      var rDisabledAttr = readOnly ? "disabled" : "";
      return {
        html: `<label for="${id}" style="color:#a39f9f;font-weight:600;" class="custom-element">${editElement.label}</label>
                        <textarea ${rDisabledAttr} ${rOnlyAttr} id="${id}" name="${id}" style="width: 100%;height: 30px; resize: none; background:#fff; color:#a39f9f;font-weight:600; border:none" data-binding="${editElement.binding}">${value}</textarea>`,
        id: id,
        value: value,
      };
    };
    OrgChart.RES.IT_IS_LONELY_HERE_LINK = "Click here to add a department.";
    if (!chart) {
      const newChart = new OrgChart(document.getElementById("orgchart"), {
        nodes: nodes,
        enableSearch: false,
        scaleInitial: nodes.length <= 4 ? 0.9 : OrgChart.match.boundary,
        // scaleInitial: OrgChart.match.boundary,
        enableDragDrop: true,
        // nodeMouseClick: OrgChart.action.none,
        siblingSeparation: 10,
        partnerNodeSeparation: 10,
        partnerChildrenSplitSeparation: 50,
        collapse: {
          level: 2,
          allChildren: true,
        },
        nodeBinding: {
          // field_0: "code",
          // field_1: "status",
          // field_2: "name",
          // field_3: "description",
          // field_4: "resource",
          // field_5: "sub",
          field_0: "name",
          field_1: "code",
          // field_2: "sub",
          field_2: "resource",
          field_3: "status",
          field_4: "description",
        },
        nodeMenu: {
          edit: {
            text: "Edit",
            onClick: (e) => {
              const ele = document.querySelector(".boc-edit-form");
              if (ele) {
                ele.style.display = "none";
              }
              resetValues();
              setModalOpen(true);
              setPId(e);
              onEdit(e);
            },
          },
          add: {
            text: "Add",
            onClick: (e) => {
              const ele = document.querySelector(".boc-edit-form");
              if (ele) {
                ele.style.display = "none";
              }
              resetValues();
              setPId(e);
              setModalOpen(true);
            },
          },
          remove: {
            text: "Remove",
            onClick: (id) => {
              const ele = document.querySelector(".boc-edit-form");
              if (ele) {
                ele.style.display = "none";
              }
              onRemove(id);
            },
          },
        },
        editForm: {
          readOnly: true,
          buttons: {
            edit: null,
            share: null,
            pdf: null,
            remove: null,
          },
          elements: [
            [
              { type: "textbox", label: "Code", binding: "code" },
              { type: "textbox", label: "Status", binding: "status" },
              // { type: "textbox", label: "Sub Department", binding: "sub" },
            ],
            { type: "textbox", label: "Name", binding: "name" },
            [{ type: "nameTextArea", label: "Manager", binding: "resource" }],
            {
              type: "myTextArea",
              label: "Description",
              binding: "description",
            },
          ],
        },
      });
      newChart.on("add", function (sender, node) {
        setModalOpen(true);
        return false;
      });
      newChart.on("drop", function (sender, targetId, position) {
        setRearrangedNodeData({
          ...rearrangedNodeData,
          id: targetId,
          pid: position,
        });
      });
      setChart(newChart);
    } else {
      chart.load(nodes);
    }
  };
  useEffect(() => {
    drawBalkanChart();
  }, [chart, nodes]);

  useEffect(() => {
    document.addEventListener("click", () => {
      const ele = document.querySelector(".boc-edit-form");
      if (ele) {
        ele.style.position = "relative";
        const div = document.createElement("div");
        div.style.height = "20px";
        div.style.width = "20px";
        div.style.borderRadius = "50%";
        div.style.border = "0.5px solid #000";
        div.style.display = "grid";
        div.style.placeItems = "center";
        div.style.position = "absolute";
        div.style.top = "2%";
        div.style.right = "5%";
        div.style.cursor = "pointer";
        const spanTag = document.createElement("span");
        spanTag.style.marginTop = "-5px";
        spanTag.textContent = "X";
        div.append(spanTag);
        div.addEventListener("click", () => (ele.style.display = "none"));
        ele.append(div);
      }
    });
  }, []);

  useEffect(() => {
    if (nodeId && isEditing) {
      const node = nodes.filter((obj) => obj.id == nodeId);
      const resources = nodesData.filter((obj) => obj.department_id == nodeId);
      const { code, status, name, description } = node[0];
      setNodeObj({
        ...nodeObj,
        code,
        status,
        name,
        description,
        resourceId: resources[0].resource_id ? resources[0].resource_id : 0,
        resource: resources[0].resource_name
          ? resources[0].resource_name
          : null,
      });
      setIsEditing(false);
    } else {
      if (nodeId && isRemoving) {
        removeNode();
      }
    }
  }, [nodeId, isEditing, isRemoving]);

  return (
    <div>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        disableBackdropClick
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span
              className={classes.closeIconAdd}
              onClick={() => setModalOpen(false)}
            >
              x
            </span>
            <div className={classes.addDelegationTitle}>
              {btnText == "Add" ? " Add Department" : " Edit Department"}
            </div>
          </div>
          {/* <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
            {btnText == "Add" ? " Add Department" : " Edit Department"}
          </h3> */}
          <div className={classes.formContainer}>
            <div className={classes.fieldTitle}>Name</div>
            <input
              className={classes.inputField}
              placeholder="Department Name"
              value={nodeObj.name}
              onChange={(e) => setNodeObj({ ...nodeObj, name: e.target.value })}
            />
            <div className={classes.fieldTitle}>Code</div>
            <input
              className={classes.inputField}
              placeholder="Department Code"
              value={nodeObj.code}
              onChange={(e) => setNodeObj({ ...nodeObj, code: e.target.value })}
            />
            <div className={classes.fieldTitle}>
              Status{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            <input
              className={classes.inputField}
              placeholder="Status"
              value={nodeObj.status}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, status: e.target.value })
              }
            />
            <div className={classes.fieldTitle}>
              Description{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            <textarea
              className={classes.inputField}
              placeholder="Short Description"
              value={nodeObj.description}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, description: e.target.value })
              }
            />
            <div className={classes.fieldTitle}>
              Manager{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            {/* <select
              className={classes.dropDown}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, resource: e.target.value })
              }
            >
              <option value="null" selected={!nodeObj.resource}>
                None
              </option>
              {departmentsResources &&
                departmentsResources.length > 0 &&
                departmentsResources.map((resource) => (
                  <option
                    value={resource.resourceId}
                    selected={nodeObj.resource == resource.resourceId}
                  >
                    {formatText(resource.resourceName)}
                  </option>
                ))}
            </select> */}

            {/* <div className={classes.fieldTitle}>Role</div> */}

            <Select
              showArrow
              showSearch
              options={[
                { label: "None", value: "None", resourceId: null },
                ...resourcesFormatted,
              ]}
              value={nodeObj.resource}
              onChange={(value, obj) =>
                setNodeObj({
                  ...nodeObj,
                  resource: value,
                  resourceId: obj.resourceId,
                })
              }
              placeholder="Select Manager"
              // defaultValue={nodeObj.resource?nodeObj.re}
            ></Select>

            <div className={classes.buttonsContainer}>
              <button
                className={classes.btn}
                style={{ marginRight: "8px" }}
                onClick={
                  btnText == "Add" ? () => addNewNode() : () => updateNode()
                }
              >
                {btnText}
              </button>
              <button
                className={classes.btn}
                style={{
                  background: "#fff",
                  border: "1px solid #0176d3",
                  color: "#0176d3",
                }}
                onClick={() => resetValues()}
              >
                Cancel
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <div id="orgchart" style={{ width: "100%", height: "550px" }}></div>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </div>
  );
};

export default DepartmentHierarchy;
